//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopRightShare from '@/components/views/top_right_share'
import CommonTabs from '@/components/views/common_tabs'
import NewTap from './new_tap'
import OldTap from './old_tap'
import mixin from './mixin'
import log_mixin from '@/common/mixins/log'
export default {
    mixins: [
        mixin,
        log_mixin('税费计算页')
    ],
    components: {
        CommonTabs,
        NewTap,
        OldTap,
        TopRightShare
    },

    data () {
        return {
            type: 'new',
            tabs: [
                {
                    key: 'new',
                    name: '新房'
                },
                {
                    key: 'old',
                    name: '二手房'
                }
            ]
        }
    },
    methods: {
        changeType (type) {
            this.type = type
        },
        openResult () {
            setTimeout(() => {
                this.$refs[this.type].calculate()
            }, 100);
        },
    }

}
